<template>
  <div>
    <v-overlay :value="loading" absolute>
        <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <div v-if="!loading">
      <app-form
        v-bind:parentObject="{
          data: this.formData[0],
          searchnew: this.search,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          errMsg: this.errMsg,
          isEdit: this.editMode,
        }"
        v-on:input="formData[0] = $event"
        v-on:new="createHandler"
        v-on:save="saveHandler"
        v-on:delete="isConfirm = !isConfirm"
        v-on:error="errorHandler"
      />

      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>

      <div v-if="isConfirm">
        <app-confirm
          v-bind:parentObject="{
            pageTitleValue: this.pageTitleValue,
            isConfirm: this.isConfirm,
          }"
          v-on:confirm="deleteHandler($event)"
          v-on:cancelConfirm="isConfirm = !isConfirm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import PsnPayrollForm from "../../../components/payroll/psnpayroll/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": PsnPayrollForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      search: this.$route.params.search,
      pageTitle: this.$t('maintenanceforpayroll.editpsnpayroll'),
      pageTitleValue: "",
      formData: [],
      errMsg: "",
      confirmMsg: "",
      isErr: false,
      loading: true,
      editMode: true,
      isConfirm: false,
      userid: this.$store.getters.userId,

    };
  },

  methods: {
    saveHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }
      if (this.formData[0].isCompnypaytax == false) {
        this.formData[0].isCompnypaytax = 0;
      } else {
        this.formData[0].isCompnypaytax = 1;
      }

      if (this.formData[0].isEis == false) {
        this.formData[0].isEis = 0;
      } else {
        this.formData[0].isEis = 1;
      }

      if (this.formData[0].isdynamic == false) {
        this.formData[0].isdynamic = 0;
      } else {
        this.formData[0].isdynamic = 1;
      }

      if (this.formData[0].epfeep == ''){this.formData[0].epfeep = null;}

      if (this.formData[0].epferp == ''){this.formData[0].epferp = null;}

      if (this.formData[0].epfeeamt == ''){this.formData[0].epfeeamt = null;}

      if (this.formData[0].epferamt == '') {this.formData[0].epferamt = null;} 

      if (this.formData[0].veeep == ''){this.formData[0].veeep = null;}

      if (this.formData[0].veerp == ''){this.formData[0].veerp = null;}

      if (this.formData[0].veeeamt == ''){this.formData[0].veeeamt = null;}

      if (this.formData[0].veeramt == ''){this.formData[0].veeramt = null;}
      
      if (this.formData[0].baieeamt == ''){this.formData[0].baieeamt = null;}

      if (this.formData[0].baieramt == ''){this.formData[0].baieramt = null;}

      if (this.formData[0].zakatp == ''){this.formData[0].zakatp = null;}

      vm.formData[0].userid = this.$store.getters.userId;

      var payload = this.formData[0];

      this.$store.dispatch('put', {url: "/psnpayroll/" + vm.id, payload: payload})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "psnpayrolllist", params: { search: this.search} });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    cancelHandler() {
      this.$router.push({ name: "psnpayrolllist" });
    },

    deleteHandler($event) {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }
      this.isConfirm = !this.isConfirm;

      if ($event) {
        this.$store.dispatch('delete', {url:
              "/psnpayroll/" +
              this.id +
              "/" +
              this.formData[0].userid})
          .then((res) => {
            if (res.data.error) {
              vm.isErr = !vm.isErr;
              vm.errMsg = res.data.error;
            } else {
              this.$router.push({ name: "psnpayrolllist" });
            }
          })
          .catch((err) => {
            vm.isErr = !vm.isErr;
            vm.errMsg = err;
          });
      }
    },

    createHandler() {
      this.$router.push({ name: "psnpayrollnew" });
    },

    loadPsnpayrollHandler() {
      const vm = this;

      return this.$store.dispatch('get', {url: "/psnpayroll/" + vm.id})
        .then((res) => {
          if (res.status == 200) {
            vm.formData = res.data.rec;
            vm.pageTitleValue = vm.formData[0].psnid;

            if (vm.formData[0].startdate) {
              vm.formData[0].startdate = moment(
                vm.formData[0].startdate
              ).format("YYYY-MM-DD");
            }

            if (vm.formData[0].enddate) {
              vm.formData[0].enddate = moment(vm.formData[0].enddate).format(
                "YYYY-MM-DD"
              );
            }

            if (vm.formData[0].isCompnypaytax === "N") {
              vm.formData[0].isCompnypaytax = false;
            } else {
              vm.formData[0].isCompnypaytax = true;
            }

            if (vm.formData[0].isEis === "N") {
              vm.formData[0].isEis = false;
            } else {
              vm.formData[0].isEis = true;
            }

            if (vm.formData[0].isdynamic == "N") {
              vm.formData[0].isdynamic = false;
            } else {
              vm.formData[0].isdynamic = true;
            }

            if (vm.formData[0].isfw === "N") {
              vm.formData[0].isfw = false;
            } else {
              vm.formData[0].isfw = true;
            }

             vm.formData.lockstaff = res.data.rec[0].lockstaff;
            vm.formData[0].userid = this.$store.getters.userId;
           // vm.formData.userid = this.$store.getters.userId;
           
           vm.loading = !vm.loading;
          } else {
            vm.isErr = !vm.isErr;
          }
        })
        .catch((err) => {
          vm.isErr = true;
          vm.errMsg = err;
        });
    },
  },

  async mounted() {
    await this.loadPsnpayrollHandler();
  },
};
</script>